import React from 'react';
import { Typography, Container, Divider } from '@mui/material';

const Delete: React.FC = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        marginTop: 4,
        marginBottom: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Page Header */}
      <Typography
        variant="h2"
        gutterBottom
        sx={{
          fontFamily: 'Montserrat',
          textAlign: 'center',
          color: 'dodgerblue',
        }}
      >
        Delete
      </Typography>
      <Divider
        sx={{
          width: '100%',                // ← full width
          borderColor: 'dodgerblue',
          borderWidth: '1px',           // thickness
          mb: 2,                        // space below
        }}
      />

        {/* Section */}
        <Typography variant="h5" gutterBottom>
          <strong>How to Delete</strong>
        </Typography>
        <Typography variant="body1">
          If you must delete your account, the APM app allows you to do so.
          Just navigate to the Profile Page in the menu. At the bottom is a link to delete your account.
          We hate to see you go, but thank you for trying us out.
        </Typography>
    </Container>
  );
};

export default Delete;
